<div class="audio-chat-card">
  <div role="button" class="audio-chat-card__actions" (click)="buffered$() ? playPause() : ''">
    <button class="audio-chat-card__actions-button" [@rotateInOut]="paused$() ? 'true' : 'void'">
      @if (!paused$() && buffered$()) {
        <fa-icon [icon]="faPause" size="lg" class="secondary"></fa-icon>
      } @else if (buffered$()) {
        <fa-icon [icon]="faPlay" size="lg" class="secondary audio-chat-card__actions-button__play"></fa-icon>
      } @else {
        <fa-icon [icon]="faSpinnerScale" size="lg" [spin]="true" class="secondary"></fa-icon>
      }
    </button>
  </div>
  <div class="audio-chat-card__audio">
    @if (buffered$()) {
      <div class="audio-chat-card__audio__progress">
        <div class="audio-chat-card__audio__progress-bar" [style.width.%]="progress$()"></div>
      </div>
      <div class="audio-chat-card__audio__time">
        <fa-icon [icon]="faMicrophone" class="bleach"></fa-icon>
        <span class="audio-chat-card__audio__time-text"> {{ progressTime$() }} / {{ duration$() }} </span>
      </div>
    }

    <audio #audioPlayer [id]="'audio' + id" controls preload="metadata">
      <source type="audio/webm" />
      <source type="audio/wav" />
      <source type="audio/mp3" />
      <source type="audio/mp4" />
    </audio>
  </div>
</div>
